// export const BACKEND_SERVER_URL = process.env.REACT_APP_API_URL || "/";
// export const LOCAL_STORAGE_USER = "ADMIN_USER";

export const BACKEND_SERVER_URL =
  process.env.REACT_APP_API_URL || "https://xp.life:8443/eats/apistore";
export const LOCAL_STORAGE_USER = "ADMIN_USER";
